import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CheckoutCancel = () => {
  return (
    <div className="pt-24 pb-16" data-testid="checkout-cancel">
      <div className="max-w-2xl mx-auto px-4 md:px-8 text-center py-16">
        <XCircle className="h-20 w-20 mx-auto mb-6 text-muted-foreground" strokeWidth={1.5} />
        <h1 className="text-3xl md:text-4xl font-heading font-bold mb-4">Payment Cancelled</h1>
        <p className="text-lg text-muted-foreground mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/cart">
            <Button variant="outline" className="rounded-full uppercase tracking-widest">
              Return to Cart
            </Button>
          </Link>
          <Link to="/products">
            <Button className="rounded-full uppercase tracking-widest">
              Continue Shopping
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
